import { __awaiter, __generator } from '../../node_modules/tslib/tslib.es6.js';
import { isIos, runningInApp, evaluateRunningInApp, iosAppBaseUrl, androidAppBaseUrl } from '../appConstants/appConstants.js';
import { goToUrl } from '../goToUrl/goToUrl.js';
import { authLogout, logoutInOldApp } from '../logout/rest-default-client/logoutSpecific.js';
import { useIpc } from '../ipcWeb/IpcContext.js';

var useCloseWebView = function () {
    var endSession = useIpc().endSession;
    var closeWebView = function (route) { return __awaiter(void 0, void 0, void 0, function () {
        var defaultIos, defaultAndroid, inApp, ipcError_1, url_1, url, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    defaultIos = 'close';
                    defaultAndroid = 'continue';
                    inApp = runningInApp || evaluateRunningInApp();
                    if (!inApp) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    Promise.all([authLogout(), logoutInOldApp()]);
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, endSession(route)];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
                case 4:
                    ipcError_1 = _a.sent();
                    // eslint-disable-next-line no-console
                    console.error('ipcError error:', ipcError_1);
                    return [3 /*break*/, 5];
                case 5:
                    // Fallback to URL-based navigation
                    if (isIos) {
                        url_1 = "".concat(iosAppBaseUrl).concat(defaultIos);
                        goToUrl(url_1);
                        return [2 /*return*/];
                    }
                    url = "".concat(androidAppBaseUrl).concat(defaultAndroid);
                    goToUrl(url);
                    return [3 /*break*/, 7];
                case 6:
                    error_1 = _a.sent();
                    // eslint-disable-next-line no-console
                    console.error('closeWebView error:', error_1);
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    return { closeWebView: closeWebView };
};

export { useCloseWebView };
